import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { RegisterPassKeyPromptComponent } from './register-pass-key-prompt.component';
import { AuthFlow } from 'src/app/set-multi-factor-auth/set-multi-factor-auth.component';

class RegisterPassKeyPromptSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  displayName: string;
  username: string;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  registerPassKeyPromptComponent: ComponentRef<RegisterPassKeyPromptComponent>;

  constructor(formId: string, payload: object) {
      console.log('Inside RegisterPassKeyPromptSession constructor');
      this.formId = formId;
      this.payload = payload;
  }

  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    console.log('Start Session - RegisterPassKeyPromptSession: ' + this.formId);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.resolver = (clientContext as any).resolver;
    this.viewContainerRef = (clientContext as any).viewContainerRef;
    this.displayName = clientContext['DisplayName'];
    this.username =  clientContext['username'];

  }
  endSession(): void {
    console.log('End Session - RegisterPassKeyPromptSession: ' + this.formId);
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    console.log('promiseFormInput - RegisterPassKeyPromptSession: ' + this.formId);
    const self = this;
    self.viewContainerRef.clear();

    const factory: ComponentFactory<RegisterPassKeyPromptComponent> = self.resolver.resolveComponentFactory(RegisterPassKeyPromptComponent);
    self.registerPassKeyPromptComponent = self.viewContainerRef.createComponent(factory);

    self.registerPassKeyPromptComponent.instance.onCreatePasskeySubmit = self.onSubmitPasskey.bind(self);
    self.registerPassKeyPromptComponent.instance.onPasskeySkipSubmit = self.onSkipPasskey.bind(self);
    self.registerPassKeyPromptComponent.instance.onPasskeyDeclineSubmit = self.onDeclinePasskey.bind(self);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    console.log('promiseFormInput-2 - RegisterPassKeyPromptSession: ' + this.formId);
    return new Promise((resolve, reject) => {
      self.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          console.log('usernameFormTs createFormInputSubmissionRequest SUCCESS payload: ', payload);
          self.submitBlock = null; // assign null to prevent using the same promise more then once
        } catch (e) {
          console.log('usernameFormTs createFormInputSubmissionRequest ERROR payload: ', payload);
          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {
    console.log('RegisterPassKeyPromptSession ' + this.formId + ' payload:', payload);
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onSubmitPasskey() {
    //this.submitBlock({result: 'enable'});
        this.setupForm.call(this);
  }

  private onSkipPasskey() {
    this.submitBlock({flow: 'passkey_cancel'});
  }

  private onDeclinePasskey() {
    this.submitBlock({flow: 'decline'});
  }

  async passkeyRegister() {
     try {
          const username = this.username;  
          const res = await (window as any).tsPlatform.webauthn.register({username,
            options: {
              limitSingleCredentialToDevice: true,
              displayName: this.displayName,
              allowCrossPlatformAuthenticators: true,
              registerAsDiscoverable: true,
              timeout: 60
            }
          });

        if (res){
          this.submitBlock({
          action: 'submit',
          webauthntoken: res
        });
      }
      else{
          console.log('webauthn.register failed');
          this.submitBlock({
          action: 'submit',
          webauthntoken: null,
          error: 'webauthn.register failed'
        });
      }

    }
    catch (e){
        this.submitBlock({
        action: 'submit',
        webauthntoken: null,
        error: 'Timeout - ' + e
      });
    }
  }

  async setupForm(){
      const self = this;

      await this.passkeyRegister();
      // $.get('passkeyregister.html', () => {
      //   // $(self.clientContext.uiContainer).html(data);

      //       $('#passkeyRegister').on('click', () => {
      //       this.passkeyRegister.call(self);

      //       // tslint:disable-next-line:indent
      //       // $('#custom-password-authenticator_cancel-button').on('click', () => {
      //       //   const escapeOptions = self.actionContext.getEscapeOptions();
      //       //   const cancelOption = escapeOptions.filter(option => option.getId() === 'cancel')[0];

      //       //   if (!cancelOption) {
      //       //     return console.error(`unable to find a "Cancel" option in actionContext.escapeOptions`);
      //       //   }
      //       //   self.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(cancelOption));
      //       // });

      //       // const showInModal = self.payload.showInModal;
      //       // if (showInModal && showInModal === true) {
      //       //     setAsModal.call(self);
      //       // }
      //   });
      // });
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default RegisterPassKeyPromptSession;
